<template>
  <vuestic-sidebar :hidden="isOpen">
    <template slot="menu">
      <sidebar-link
        :to="{ name: 'home' }">
        <span slot="title">
          <span
            class="sidebar-menu-item-icon va-icon entypo entypo-globe"></span>
          <span>{{ $t('menu.home') }}</span>
        </span>
      </sidebar-link>

      <sidebar-link :to="{ name: 'create' }">>
        <span slot="title">
          <span
            class="sidebar-menu-item-icon va-icon entypo entypo-plus"></span>
          <span>{{ $t('trip.create.title') }}</span>
        </span>
      </sidebar-link>

      <sidebar-link :to="{ name: 'reports' }">>
        <span slot="title">
          <span
            class="sidebar-menu-item-icon vuestic-icon vuestic-icon-statistics"></span>
          <span>{{ $t('reports.name') }}</span>
        </span>
      </sidebar-link>

    </template>
  </vuestic-sidebar>
</template>

<script>

import VuesticSidebar
  from '../../../vuestic-theme/vuestic-components/vuestic-sidebar/VuesticSidebar'
import SidebarLink from './components/SidebarLink'
import SidebarLinkGroup from './components/SidebarLinkGroup'

export default {
  name: 'app-sidebar',
  components: {
    VuesticSidebar,
    SidebarLink,
    SidebarLinkGroup,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
}

</script>
